import { createContext,useEffect,useReducer } from "react";

export const CoachAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'COACH_LOGIN':
        return {coach: action.payload}

        case 'COACH_LOGOUT':
            return {
                coach:null,
            }

        case "UPDATE_ACCOUNT_TYPE":
            return {
                coach: {
                ...state.coach,
                account_type: action.payload, // Update account_type
                },
            };
        
            case "UPDATE_ACCOUNT_PHOTO":
                return {
                    coach: {
                    ...state.coach,
                    photo: action.payload, // Update photo
                    },
                    };

        default:
            return state;    
    }
}

export const CoachAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        coach:null
    });

    useEffect(()=>{
        const coach = JSON.parse(localStorage.getItem('coach'));
        if(coach){
            dispatch({type:'COACH_LOGIN', payload:coach});
        }

    },[]);

    console.log('CoachAuthContext State ', state);

    return (
        <CoachAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </CoachAuthContext.Provider>
    )
}